import React, { FC, useState } from "react";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { IconButton, Menu, MenuItem, Typography } from "@mui/material";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

type DiscountedProductsTableActionMenuProps = {
  onRemove: () => void;
};
export const DiscountedProductsTableActionMenu: FC<DiscountedProductsTableActionMenuProps> = ({ onRemove }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton
        id={"actionMenuButton"}
        aria-controls={open ? "actionMenu" : undefined}
        aria-haspopup={"true"}
        aria-expanded={open ? "true" : undefined}
        onClick={(e) => setAnchorEl(e.currentTarget)}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id={"actionMenu"}
        aria-labelledby={"actionMenu"}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        MenuListProps={{
          "aria-labelledby": "actionMenuButton",
        }}
      >
        <MenuItem
          onClick={() => {
            onRemove();
            handleClose();
          }}
        >
          <DeleteForeverIcon />
          <Typography>Remove</Typography>
        </MenuItem>
      </Menu>
    </>
  );
};
